import React from 'react'
import { withRouter } from 'react-router-dom'
const HomeIconItem = ({ iconHeight,title, iconLeft,iconWidth, iconTop, toUrl, borderColor,iconMarginLeft, history, ...props }) => {
    iconWidth=iconWidth||31;
    iconHeight=iconHeight||31;
    iconMarginLeft=iconMarginLeft||0
    const gotoIconLink = () => {
        const isAbsUrl = toUrl.toLowerCase().startsWith('http');
        if (isAbsUrl) {
            window.open(toUrl);
        } else {
            history.push({
                pathname: toUrl
            })
        }
    }
    return (
        <div className='icon-item-wrap' onClick={() => gotoIconLink()}>

            <div className='icon-item' style={{
                borderColor: `#${borderColor}`
            }}>
                <div className='icon-item-img' style={{
                    backgroundPosition: `${iconLeft}px ${iconTop}px`,
                    marginLeft:`${iconMarginLeft}px`,
                    width:`${iconWidth}px`,
                    height:`${iconHeight}px`
                }}></div>
            </div>
            <span className='icon-text'>{title}</span>
        </div>
    )
}

export default withRouter(HomeIconItem)
